$inner-background-color: #2069e0;
$button-text-color: #282828;

.sn-call-to-action-type-5 {
    &__container {
        @include container;

        // The `container` mixin caps at $media-desktop (1440); match the signnow
        // me-container width instead to line up with the rest of the page.
        max-width: $sn-container-max-width;
        padding-top: 0;
        padding-bottom: $spacing-5xl;

        @include desktop {
            padding-top: 0;
            padding-bottom: $spacing-6xl;
        }

        @include desktop-lg {
            padding-bottom: $spacing-7xl;
        }
    }

    &__inner {
        background-color: $inner-background-color;
        border-radius: map-get($border-radii, lg);
        padding: var(--spacing-3xl) var(--spacing-xl);
        text-align: center;
        color: $color-neutral-white;

        @include desktop {
            padding: var(--spacing-5xl) var(--spacing-5xl);
        }

        .me-text--label {
            display: block;
            text-transform: uppercase;
            letter-spacing: 3px;
            font-size: map-get($font-sizes, md);
            font-weight: map-get($font-weights, bold);
            margin: 0 0 var(--spacing-sm);
        }

        .me-heading {
            display: block;
            font-size: map-get($font-sizes, 4xl);
            font-weight: map-get($font-weights, bold);
            line-height: map-get($line-heights, xl);
            margin: 0 0 var(--spacing-xl);

            @include desktop {
                font-size: map-get($font-sizes, 6xl);
            }
        }
    }

    &__action {
        display: inline-block;

        .me-button {
            border-radius: var(--radius-size-sm);
            overflow: hidden;
            min-width: 208px;

            // CTA button: 208×48. The height comes from the padding — 24px line-height
            // + 2×2px border + 2×10px padding. The theme rule
            // `body.signnow [data-color-mode] .me-button--primary` is (0,3,1) and outranks the
            // three classes here, so the `[data-color-mode]` ancestor is matched too — (0,4,0).
            [data-color-mode] &.me-button--primary {
                padding: 0.625rem 1.2rem;

                // Not `var(--action-color-brand-primary)`: on a page with `body.signnow` the
                // theme guard `body.signnow [data-color-mode]` (0,2,1) outranks the
                // `[data-color-mode='inverted']` (0,1,0) sitting on this button and replaces
                // that custom property with the brand blue. `$color-neutral-white` is a
                // primitive token, declared once at :root and never re-themed.
                background-color: $color-neutral-white;
                border-color: $color-neutral-white;
                color: $button-text-color;

                &:hover {
                  background-color: $inner-background-color;
                  border: $border-size-md solid $color-neutral-white;
                  color: $color-neutral-white;
                }
            }
        }
    }
}
